import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { ActionNames, fetchedOrder, FetchOrder, listOrderResult, ListOrders } from '../actions';

const fetch = window.fetch.bind(window);

const host = '';
const hostPrefix = host ? `://${host}` : '';
const apiUrl = (route: string) => `${hostPrefix}/${route}`;

function* listOrders(action: ListOrders) {
    const resp = yield call(fetch, apiUrl('api/customer/orders'));
    const reviews = yield call(resp.json.bind(resp));

    if (action.done) {
        action.done();
    }

    yield put(listOrderResult(reviews));
}

function* fetchOrder(action: FetchOrder) {
    const resp = yield call(fetch, apiUrl(`api/customer/orders/${action.id}`));
    const order = yield call(resp.json.bind(resp));

    yield put(fetchedOrder(order));

    if (action.done) {
        action.done();
    }
}

function* handeList() {
    yield takeLatest(ActionNames.OrderActions.list, listOrders);
}

function* handleFetch() {
    yield takeLatest(ActionNames.OrderActions.fetch, fetchOrder);
}

function* handleReviews() {
    yield all([
        fork(handeList),
        fork(handleFetch)
    ]);
}

export default handleReviews;
